module.exports = __webpack_public_path__ + "img/qkw_loutai_shui.fbcdf3f4.gif";